module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sales-volume-configure-panel"
  }, [_c('div', {
    staticClass: "sales-volume-configure-header"
  }, [_c('div', [_c('div', {
    staticClass: "sales-volume-configure-title"
  }, [_vm._v("Sales Volume Alert Thresholds")]), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-configure-subtitle"
  }, [_vm._v("\n        Listings and saved thresholds come from the API. Changes apply to all future alerts for that product.\n      ")]), _vm._v(" "), (_vm.listTotal > _vm.listRows.length) ? _c('div', {
    staticClass: "sales-volume-configure-cap-note"
  }, [_vm._v("\n        Showing " + _vm._s(_vm.listRows.length) + " of " + _vm._s(_vm.listTotal) + " listings (page " + _vm._s(_vm.listPage) + ").\n        Use Download CSV to edit the rest in bulk.\n      ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "sales-volume-configure-close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "close icon"
  })])]), _vm._v(" "), (_vm.thresholdsLoadError) ? _c('div', {
    staticClass: "sales-volume-thresholds-load-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.thresholdsLoadError) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-subtype-tabs"
  }, _vm._l((_vm.subtypeTabs), function(tab) {
    return _c('button', {
      key: tab.id,
      class: ['sales-volume-subtype-tab', {
        active: _vm.salesSubtype === tab.id
      }],
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.salesSubtype = tab.id
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-pane-body"
  }, [(_vm.salesSubtype === 'hours') ? _c('p', {
    staticClass: "sales-volume-pane-desc"
  }, [_vm._v("\n      Alert when a product has had no sales for this many consecutive hours. Default: 72 hrs.\n    ")]) : (_vm.salesSubtype === 'fixed') ? _c('p', {
    staticClass: "sales-volume-pane-desc"
  }, [_vm._v("\n      Set absolute daily sales floor/ceiling. Alert fires when sales drop below or spike above these values.\n    ")]) : (_vm.salesSubtype === 'rolling') ? _c('p', {
    staticClass: "sales-volume-pane-desc"
  }, [_vm._v("\n      Alert when daily sales deviate from the rolling average by a percentage.\n    ")]) : (_vm.salesSubtype === 'bsr') ? _c('p', {
    staticClass: "sales-volume-pane-desc"
  }, [_vm._v("\n      Alert when Best Seller Rank spikes above this number (higher rank = fewer sales).\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-table-wrap"
  }, [_c('table', {
    staticClass: "sales-volume-settings-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-product"
  }, [_vm._v("Listing")]), _vm._v(" "), _c('th', {
    staticClass: "col-mkt"
  }, [_vm._v("Mkt")]), _vm._v(" "), _vm._l((_vm.activeColumns), function(col) {
    return _c('th', {
      key: col.key
    }, [_vm._v(_vm._s(col.label))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.listRows), function(row) {
    return _c('tr', {
      key: _vm.rowKey(row)
    }, [_c('td', [_c('div', {
      staticClass: "sales-volume-asin-info"
    }, [_c('span', {
      staticClass: "sales-volume-asin-name"
    }, [_vm._v(_vm._s(row.asin || '—'))]), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-asin-code"
    }, [_vm._v("ID " + _vm._s(row.productId))])])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "sales-volume-mkt"
    }, [_c('i', {
      class: _vm.marketplaceFlagClass(row.marketplace) + ' flag'
    }), _vm._v("\n                " + _vm._s(_vm.marketplaceCode(row.marketplace)) + "\n              ")])]), _vm._v(" "), (_vm.salesSubtype === 'hours') ? [_c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].noSalesHours),
        expression: "forms[rowKey(row)].noSalesHours",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "placeholder": "72 (default)"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].noSalesHours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "noSalesHours", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("hours")])])])] : (_vm.salesSubtype === 'fixed') ? [_c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].dailyFloor),
        expression: "forms[rowKey(row)].dailyFloor",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].dailyFloor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "dailyFloor", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("units/day")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].dailyCeiling),
        expression: "forms[rowKey(row)].dailyCeiling",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].dailyCeiling)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "dailyCeiling", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("units/day")])])])] : (_vm.salesSubtype === 'rolling') ? [_c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].rollingDrop),
        expression: "forms[rowKey(row)].rollingDrop",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "max": "100",
        "placeholder": "30 (default)"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].rollingDrop)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "rollingDrop", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("%")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].rollingSpike),
        expression: "forms[rowKey(row)].rollingSpike",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "max": "100",
        "placeholder": "—"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].rollingSpike)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "rollingSpike", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("%")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].rollingDays),
        expression: "forms[rowKey(row)].rollingDays",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "placeholder": "14 (default)"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].rollingDays)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "rollingDays", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("days")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].rollingMinUnits),
        expression: "forms[rowKey(row)].rollingMinUnits",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "0",
        "placeholder": "3 (default)"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].rollingMinUnits)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "rollingMinUnits", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sales-volume-threshold-unit"
    }, [_vm._v("units")])])])] : (_vm.salesSubtype === 'bsr') ? [_c('td', [_c('div', {
      staticClass: "sales-volume-input-wrap"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.forms[_vm.rowKey(row)].bsrAbove),
        expression: "forms[rowKey(row)].bsrAbove",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "sales-volume-threshold-input",
      attrs: {
        "type": "number",
        "min": "1",
        "placeholder": "not set"
      },
      domProps: {
        "value": (_vm.forms[_vm.rowKey(row)].bsrAbove)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.forms[_vm.rowKey(row)], "bsrAbove", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])] : _vm._e()], 2)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-csv-strip"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-csv-actions"
  }, [_c('button', {
    staticClass: "sales-volume-btn-csv sales-volume-btn-csv-dl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadCsv
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n        Download CSV\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "sales-volume-csv-divider"
  }), _vm._v(" "), _c('label', {
    staticClass: "sales-volume-btn-csv sales-volume-btn-csv-ul"
  }, [_c('i', {
    staticClass: "upload icon"
  }), _vm._v("\n        Upload CSV\n        "), _c('input', {
    staticClass: "sales-volume-csv-file",
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.importCsv
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-panel-footer"
  }, [_c('span', {
    staticClass: "sales-volume-footer-note"
  }, [_vm._v("Changes apply to future alerts only — existing alerts are unaffected.")]), _vm._v(" "), _c('div', {
    staticClass: "sales-volume-footer-actions"
  }, [_c('button', {
    staticClass: "sales-volume-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "sales-volume-btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || _vm.listRows.length === 0
    },
    on: {
      "click": _vm.saveAll
    }
  }, [(_vm.saving) ? _c('i', {
    staticClass: "notched circle loading icon"
  }) : _vm._e(), _vm._v("\n        Save Changes\n      ")])])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "sales-volume-panel-error"
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sales-volume-csv-label"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v("\n      Large catalog?\n      "), _c('strong', [_vm._v("Download → edit in bulk → re-upload")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-286e15e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/issues/SalesVolumeThresholdsPanel.vue
// module id = 738
// module chunks = 2